// @flow
import React, { Component } from "react";
import classNames from "classnames";
import { withGlobalContext } from "../../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";
import enhanceWithClickOutside from "react-click-outside";
import Color from "color";

import type { $Site } from "flow/types";

import RenderNav from "../RenderNav";
import LoginLinks from "../LoginLinks";
import RenderContactInfo from "../RenderContactInfo";
import RenderLogo from "../RenderLogo";

type $Props = {
  classes: Object,
  onCloseDropdown: Function,
  compliance: Object,
  onToggleDropdown: Function,
  openDropdowns: Object,
  site: $Site,
};

class RightSideNav extends Component<$Props> {
  handleClickOutside() {
    this.props.onCloseDropdown();
  }
  render() {
    const {
      classes,
      compliance,
      onToggleDropdown,
      openDropdowns,
      site,
    } = this.props;
    return (
      <header
        className={classNames(classes.root, {
          [classes.stickyHeaderMargin]:
            compliance &&
            (compliance.stickyHeader ||
              compliance.stickyHeaderCustom ||
              compliance.stickyHeaderMobile),
          [classes.stickerHeaderMarginLarge]:
            compliance &&
            (compliance.stickyHeader || compliance.stickyHeaderMobile) &&
            compliance.stickyHeaderCustom,
        })}
      >
        <div className={classes.container}>
          <div className={classes.agentPhoto}>
            <RenderLogo />
          </div>
          <div className={classes.navRow}>
            <div className={classes.headerFlexinAboveNav}>
              <RenderContactInfo />
              <div className={classes.navBarTop}>
                {site.uiConfig.loginEnabled ? <LoginLinks /> : null}
              </div>
            </div>

            <div className={classes.navTable}>
              <RenderNav
                openDropdowns={openDropdowns}
                onToggleDropdown={onToggleDropdown}
              />
            </div>
          </div>
        </div>
      </header>
    );
  }
}

const styles = (theme) => {
  const hoverColor = Color(theme.colors.primary["500"])
    .darken(0.5)
    .string();
  return {
    "@global": {
      "header a svg, header li svg": {
        verticalAlign: "top",
        marginTop: "-2px",
      },
    },
    root: {
      boxSizing: "border-box",
      position: "relative",
      color: theme.colors.white,
      backgroundColor: theme.colors.primary["500"],
      [theme.breakpoints(900)]: {
        textAlign: "left",
        lineHeight: "1.5",
        padding: "0px",
        fontSize: "13px",
        zIndex: theme.zIndex["header"],
      },
    },
    stickyHeaderMargin: {
      marginTop: theme.spacing.unit * 2,
    },
    stickerHeaderMarginLarge: {
      marginTop: theme.spacing.unit * 4,
    },
    container: {
      display: "flex",
      padding: "0",
      margin: "0 auto",
      [theme.breakpoints(900)]: {
        paddingRight: theme.spacing.unit,
        paddingLeft: theme.spacing.unit,
        width: "100%",
      },
      [theme.breakpoints(992)]: {
        width: "970px",
      },
      [theme.breakpoints(1200)]: {
        width: "1170px",
      },
    },
    agentPhoto: {
      display: "none",
      position: "relative",
      maxWidth: "120px",
      "& img": {
        display: "block",
        maxWidth: "100%",
        height: "auto",
        maxHeight: "100px",
      },
      [theme.breakpoints(900)]: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: "6px 0",
      },
    },
    navRow: {
      flex: "1 1 0%",
      display: "flex",
      flexDirection: "column",
    },
    headerFlexinAboveNav: {
      flex: "1 1 0%",
      display: "none",
      position: "relative",
      justifyContent: "flex-end",
      alignItems: "center",
      marginRight: theme.spacing.unit,
      marginTop: theme.spacing.unit * 0.5,
      paddingRight: theme.spacing.unit * 0.75,
      backgroundColor: "transparent",
      "& > a": {
        color: theme.colors.primaryFontColor,
        marginRight: theme.spacing.unit * 1.5,
        fontSize: "16px",
      },
      [theme.breakpoints(900)]: {
        display: "flex",
      },
    },
    navBarTop: {
      display: "none",
      marginBottom: "0",
      backgroundColor: "transparent",
      flexShrink: "1",
      textAlign: "center",
      "& > a": {
        padding: "10px 15px",
        fontSize: "14px",
        color: theme.colors.primaryFontColor,
        "&:first-of-type": {
          marginRight: theme.spacing.unit * 1.5,
        },
        "&:hover": {
          backgroundColor: hoverColor,
          textDecoration: "none",
        },
      },
      [theme.breakpoints(900)]: {
        display: "block",
      },
    },
    navTable: {
      paddingLeft: 0,
      marginBottom: 0,
      listStyle: "none",
      flex: "1 1 0%",
      display: "block",
    },
  };
};

export default withGlobalContext(
  withStyles(styles)(enhanceWithClickOutside(RightSideNav))
);
